import axios from 'axios';

export const adminLogin = user_data =>
  axios.post('/b/admin/login', {
    username: user_data.user_name,
    password: user_data.password,
  });

export const refreshToken = data =>
  axios.post('/b/refresh_token', {
    refresh: data,
  });

export const removeToken = () =>
  axios.post('/b/remove_token');